import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EmptyListDirective } from './empty-list.directive';

@NgModule({
  declarations: [
    EmptyListDirective
  ],
  imports: [
    CommonModule
  ],
  exports: [
    EmptyListDirective
  ]
})
export class EmptyListModule { }
